
function CONTROL_OF_FILES(files) {
  let valid = true
  for (let i = 0; i < files.length; i++) {
    const element = files[i]
    if (!element.type.includes('image/')) valid = false
  }
  return valid
}
import { mapGetters } from 'vuex'
import CheckMobileApp from '~/mixins/CheckMobileApp'
export default {
  mixins: [CheckMobileApp],
  data() {
    return {
      isDragging: false,
      fileList: [],
    }
  },
  props: {
    deleteLoading: {
      default: false,
    },
    width: {
      default: 680,
    },
    percent: {
      default: 0,
    },
    uploading: {
      default: false,
    },
    files: {
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({
      getSettings: 'getSettings',
    }),
  },
  methods: {
    clickUpload() {
      this.$refs.file.click()
      if (this.isMobileApp) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'filePermission',
            data: '',
          })
        )
      }
    },
    GET_DROP_ITEM(e) {
      e.preventDefault()
      this.isDragging = false
      const files = e.dataTransfer.files
      if (!CONTROL_OF_FILES(files)) return
      this.$refs.file.files = files
      this.UPLOAD_FILES(files)
    },
    SET_FILES(e) {
      this.UPLOAD_FILES(e.target.files)
    },
    async UPLOAD_FILES(files) {
      if (files.length === 0) return
      const vm = this
      this.fileList = files
      var video = document.createElement('video')
      video.preload = 'metadata'

      video.onloadedmetadata = function () {
        window.URL.revokeObjectURL(video.src)
        var duration = video.duration
        if (duration > 300 || files[0].size > 250000000) {
          vm.$emit('fail:video', files[0], duration)
        }
      }

      video.src = URL.createObjectURL(files[0])
      this.$emit('response:file', files[0])
    },
  },
}
